// extracted by mini-css-extract-plugin
module.exports = {"CountryCircle":"country-circle_CountryCircle__Kr50q"};